import React, { createContext, useContext } from 'react';

interface StripeContextType {
  publishableKey: string;
}

const StripeContext = createContext<StripeContextType | undefined>(undefined);

export function useStripe() {
  const context = useContext(StripeContext);
  if (context === undefined) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
}

interface StripeProviderProps {
  children: React.ReactNode;
}

export function StripeProvider({ children }: StripeProviderProps) {
  // Use test key for now - will be replaced with real key when user adds it
  const publishableKey = 'pk_test_demo_key';

  return (
    <StripeContext.Provider value={{ publishableKey }}>
      {children}
    </StripeContext.Provider>
  );
}